// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202602131637/js/" + chunkId + "." + {"44":"5a42791d","225":"f65eb69c","481":"1824941a","486":"38c3716f","770":"4f549b26"}[chunkId] + ".0.16250470422498742.chunk.js";
};